import Vue from "vue"
import VueRouter from "vue-router"
import App from "@/layout/routerView.vue"
import Store from "@/store/"
import { Notify } from "vant"
Vue.use(VueRouter)
import "./routerBugFix"
const routes = [
  {
    path: "/",
    name: "App",
    component: App,
    redirect: "/home/homePage",
    children: [
      {
        path: "/home/homePage",
        name: "home",
        component: () => import(/* webpackChunkName: "Home" */ "@/views/home"),
        meta: {
          auth: false,
          title: "首页"
        }
      },
      {
        path: "signUp",
        name: "signUp",
        component: () => import(/* webpackChunkName: "Home" */ "@/views/signUp/index1.vue")
      },
      {
        path: "/home/vipService",
        name: "vipService",
        component: () => import(/* webpackChunkName: "vipService" */ "@/views/vipService"),
        meta: {
          auth: false,
          title: "会员服务"
        }
      },
      {
        path: "clause",
        name: "clause",
        component: () => import(/* webpackChunkName: "Home" */ "@/views/clause")
      },
      {
        path: "/goods/library",
        name: "productList",
        component: () => import(/* webpackChunkName: "productList" */ "@/views/productList"),
        meta: {
          auth: false,
          title: "商品列表"
        }
      },
      {
        path: "/goods/detail",
        name: "productDetail",
        component: () => import(/* webpackChunkName: "productDetail" */ "@/views/productDetail"),
        meta: {
          auth: false
        }
      },
      {
        path: "/home/productDesignDetail",
        name: "homeProductDetail",
        component: () => import(/* webpackChunkName: "productDetail" */ "@/views/productDetail"),
        meta: {
          auth: false
        }
      },

      {
        path: "/home/college",
        name: "college",
        component: () => import(/* webpackChunkName: "college" */ "@/views/college"),
        meta: {
          auth: false,
          title: "商学院"
        }
      },

      {
        path: "goodList",
        name: "goodList",
        component: () => import(/* webpackChunkName: "goodList" */ "@/views/goodList"),
        meta: {
          auth: true,
          title: "商品库"
        }
      },
      {
        path: "/views/main",
        name: "main",
        component: () => import(/* webpackChunkName: "main" */ "@/views/main"),
        meta: {
          auth: true,
          title: "工作台"
        }
      },
      {
        path: "/myOrder/orderAdmin",
        name: "myOrder",
        component: () => import(/* webpackChunkName: "myOrder" */ "@/views/myOrder"),
        meta: {
          auth: true,
          title: "订单管理"
        }
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import(/* webpackChunkName: "orderDetail" */ "@/views/myOrder/orderDetail.vue"),
        meta: {
          auth: true,
          title: "订单管理"
        }
      },
      {
        path: "/orderFBA/orderAdmin",
        name: "fbaOrder",
        component: () => import(/* webpackChunkName: "fbaOrder" */ "@/views/fbaOrder"),
        meta: {
          auth: true,
          title: "FBA订单"
        }
      },
      {
        path: "fbaOrderDetail",
        name: "fbaOrderDetail",
        component: () => import(/* webpackChunkName: "fbaOrderDetail" */ "@/views/fbaOrder/fbaOrderDetail.vue"),
        meta: {
          auth: true,
          title: "FBA订单"
        }
      },
      {
        path: "/product/library",
        name: "productLibrary",
        component: () => import(/* webpackChunkName: "productLibrary" */ "@/views/productLibrary"),
        meta: {
          auth: true,
          title: "产品库"
        }
      },
      {
        path: "productLibraryDetail",
        name: "productLibraryDetail",
        component: () =>
          import(/* webpackChunkName: "productLibraryDetail" */ "@/views/productLibrary/productLibraryDetail.vue"),
        meta: {
          auth: true,
          title: "产品库"
        }
      },
      {
        path: "/setting/tradingRecord",
        name: "tradingRecord",
        component: () => import(/* webpackChunkName: "tradingRecord" */ "@/views/tradingRecord"),
        meta: {
          auth: true,
          title: "交易记录"
        }
      },
      {
        path: "tradingRecordDetail",
        name: "tradingRecordDetail",
        component: () =>
          import(/* webpackChunkName: "tradingRecordDetail" */ "@/views/tradingRecord/tradingRecordDetail.vue"),
        meta: {
          auth: true,
          title: "交易记录详情"
        }
      },
      {
        path: "/setting/recharge",
        name: "recharge",
        component: () => import(/* webpackChunkName: "orderDetail" */ "@/views/recharge"),
        meta: {
          auth: true,
          title: "会员充值"
        }
      },
      {
        path: "/gallery/openGallery",
        name: "openGallery",
        component: () => import(/* webpackChunkName: "openGallery" */ "@/views/gallery/openGallery"),
        meta: {
          auth: true,
          title: "共享图库"
        }
      },
      {
        path: "/gallery/myGallery",
        name: "myGallery",
        component: () => import(/* webpackChunkName: "myGallery" */ "@/views/gallery/myGallery"),
        meta: {
          auth: true,
          title: "我的图库"
        }
      },
      {
        path: "/gallery/singleGallery",
        name: "singleGallery",
        component: () => import(/* webpackChunkName: "singleGallery" */ "@/views/gallery/singleGallery"),
        meta: {
          auth: true,
          title: "出单图库"
        }
      },
      {
        path: "imgDetailOpen",
        name: "imgDetailOpen",
        component: () =>
          import(/* webpackChunkName: "imgDetailOpen" */ "@/views/gallery/openGallery/imgDetailOpen.vue"),
        meta: {
          auth: true,
          title: "图库详情"
        }
      },
      {
        path: "imgDetailSingle",
        name: "imgDetailSingle",
        component: () =>
          import(/* webpackChunkName: "imgDetailSingle" */ "@/views/gallery/singleGallery/imgDetailSingle.vue"),
        meta: {
          auth: true,
          title: "图库详情"
        }
      },
      {
        path: "imgDetailMy",
        name: "imgDetailMy",
        component: () => import(/* webpackChunkName: "imgDetailMy" */ "@/views/gallery/myGallery/imgDetailMy.vue"),
        meta: {
          auth: true,
          title: "图库详情"
        }
      },
      {
        path: "/main/cart",
        name: "cart",
        component: () => import(/* webpackChunkName: "cart" */ "@/views/cart"),
        meta: {
          auth: true,
          title: "购物车"
        }
      },
      {
        path: "/main/cartCheckout",
        name: "cartCheckout",
        component: () => import(/* webpackChunkName: "cartCheckout" */ "@/views/cartCheckout"),
        meta: {
          auth: true,
          title: "核对订单信息"
        }
      },
      {
        path: "/myOrder/orderPay",
        name: "orderPay",
        component: () => import(/* webpackChunkName: "orderPay" */ "@/views/orderPay"),
        meta: {
          auth: true,
          title: "余额支付"
        }
      },
      {
        path: "/home/blog",
        name: "Blog",
        component: () => import(/* webpackChunkName: "vipService" */ "@/views/blog"),
        meta: {
          auth: false,
          title: "博客"
        }
      },
      {
        path: "/home/userWelfare",
        name: "userWelfare",
        component: () => import(/* webpackChunkName: "aboutUs" */ "@/views/userWelfare/index.vue")
      },
      {
        path: "/setting/payWait",
        name: "payWait",
        component: () => import(/* webpackChunkName: "tradingRecord" */ "@/views/payWait"),
        meta: {
          auth: true,
          title: "待支付账款"
        }
      }
    ]
  },
  {
    path: "/home",
    name: "App",
    component: App,
    redirect: "/home/homePage"
  },
  {
    path: "/home/collectInfo",
    name: "collectInfo",
    component: () => import("@/views/collectInfo/index.vue")
  },
  {
    path: "*",
    name: "App",
    component: App,
    redirect: "/home/homePage"
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (Vue.ls.get("token")) {
    // 请求 user
    Store.dispatch("GetInfo")
    Store.commit("SET_TOKEN", Vue.ls.get("token"))
    next()
  } else {
    if (to.meta.auth) {
      Notify({
        type: "warning",
        message: "请先登录"
      })
      next("/home")
    }
    next()
  }
})
export default router
